import React, { useEffect, useState } from "react";
import GCTitleSticky from "./GCTitleSticky";
import {
  Box,
  CircularProgress,
  Grid,
  Modal,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Audit_Arr, Audit_Data_Load } from "../../../Server/ApiV2";
import moment from "moment";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { GetGitterColumns } from "../../../Utility/Utilitys";

const GCAuditTblCard = ({
  trnTyp = "",
  vocNo = "",
  vocTyp = "",
  xLabel = "",
  xOpen = false,
  fCloseAuditModal,
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const [GridDataAuditColumns, setGridDataAuditColumns] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },

    {
      field: "User",
      headerName: "User Name",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Date",
      headerName: "Date",
      width: 100,
      headerClassName: "grid-header-row",
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "Time",
      headerName: "Time",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "IP Address",
      headerName: "IP Address",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Old Value",
      headerName: "Old Value",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "New Value",
      headerName: "New Value",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 250,
      headerClassName: "grid-header-row",
    },
  ]);
  const [sAuditArrayValue, setAuditArrayValue] = useState("All"); // State to hold the selected option
  const [sAuditData, setAuditData] = useState([]); // State to hold the fetched audit data
  const [sAuditArray, setAuditArray] = useState([]); // State to hold the options for select

  const getAudiArr = async () => {

    const auditArr = await Audit_Arr({ trnTyp:trnTyp });
   
    if (auditArr.status == 200) {
      setAuditArray(auditArr.data.ResultSet);
    }
    if (auditArr?.data?.ResultSet?.length > 0) { 
      setAuditArrayValue(auditArr?.data?.ResultSet[0]?.id);
    }
  };

  const handleModalClose = () => {
    setAuditArray([]); // clear selected values when modal is closed
    setAuditData([]); // clear selected values when modal is closed
    fCloseAuditModal(false);
  };

  const handleSelectChange = async (event) => { 
    setAuditArrayValue(event.target.value); // Update selected option state
    getAuditData(event.target.value)
  };

  const getAuditData = async (auditdata=sAuditArrayValue) => {
    const auditData = await Audit_Data_Load({
      vocNo,
      vocTyp,
      trnTyp,
      field: auditdata,
    });
    if (auditData.status === 200 && auditData.data.ResultSet.length > 0) {
      let Auditrow =auditData.data.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setAuditData(Auditrow); // Update audit data state
    }else{
      setAuditData([]); 
    }
  };

  useEffect(() => {
    getAudiArr();
  }, [xOpen]);

  useEffect(() => {
    getAuditData(); 
  }, [xOpen]); // This effect will run whenever any of these dependencies change

  useEffect(() => {
    GetGitterColumns(
      setGridDataAuditColumns,
      "WMS_SALES_INVOICE_AUDIT",
      GridDataAuditColumns
    );
  },[])

  return (
    <>
      <Modal
        open={xOpen}
        onClose={handleModalClose} // Close the modal when clicking outside or pressing ESC key
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{ flexGrow: 1, overflow: "auto" }}
          className="gnr-item-search model-gc-search"
        >
          <GCTitleSticky title={"Audit"} onClose={handleModalClose} />

          <div className="p-2">
            <Grid
              container
              spacing={1}
              columns={{ xs: 4, sm: 4, md: 12 }}
              className="mt-2 justify-content-between"
            >
              <Grid item xs={4} className="gnr-item-search-label ">
                {xLabel}
              </Grid>
              <Grid item xs={3}>
                <div className="grn-header-checkbox">
                  <select
                    className="form-select form-select-sm"
                    //name={xAuditId}
                    value={sAuditArrayValue}
                    onChange={handleSelectChange}
                  >
                    {/* <option value="">Select</option> */}
                    {sAuditArray.map((option, index) => (
                      <option
                        className="py-2"
                        value={option.id}
                        key={"auditfield" + index}
                      >
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={1} className="search-item ">
              <Grid
                item
                xs={12}
                className=" height-table-scroll"
                component="div"
              >
                <div
                  style={{
                    height: vMediaQuery ? "60vh" : "65vh",
                    width: "100%",
                  }}
                  id="table-main-grid-3"
                  className="search-grid-table mt-2"
                >
                  <Box style={{ height: "100%", width: "100%" }}>
                    <DataGrid
                      rowHeight={30}
                      headerHeight={40}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "mui-even-row"
                          : "mui-odd-row"
                      }
                      sx={{
                        border: 1,
                        borderColor: "primary.light",
                      }}
                      rows={sAuditData}
                      columns={GridDataAuditColumns
                      }
                      getRowId={(row) => row.id}
                      hideFooter={sAuditData.length < 100}
                      components={{
                        Toolbar: GridToolbar,
                      }}
                    />
                  </Box>
                </div>
              </Grid>
            </Grid>
          </div>
          
          {/* <Grid container spacing={1} className="easy-putaway-container mt-1 p-2">
            {sAuditData?.map((item, index) => (
              <Grid
                item
                xs={12}
                sm={12}
                md={12} 
                key={index}
               
              >
                <div className="easy-putaway-card">
                  <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>
                    <Grid item xs={6} md={3}>
                      <Typography variant="subtitle1" className="label">
                        User Name
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography variant="body1" className="value">
                        {item.User}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography variant="subtitle1" className="label">
                        Date
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography variant="body1" className="value">
                        {moment(item.Date).format("DD/MM/YYYY")}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography variant="subtitle1" className="label">
                        Time
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography variant="body1" className="value">
                        {item.Time}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} md={3}>
                      <Typography variant="subtitle1" className="label">
                        IP Address
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography variant="body1" className="value">
                        {item["IP Address"]}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} md={3}>
                      <Typography variant="subtitle1" className="label">
                        Old Value
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography variant="body1" className="value">
                        {item["Old Value"]}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} md={3}>
                      <Typography variant="subtitle1" className="label">
                        New Value
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography variant="body1" className="value">
                        {item["New Value"]}
                      </Typography>
                    </Grid>

                    <Grid item xs={6} md={3}>
                      <Typography variant="subtitle1" className="label">
                        Item code
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography variant="body1" className="value">
                        {item.ItmCd}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography variant="subtitle1" className="label">
                        Item Name
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <Typography variant="body1" className="value">
                        {item.ItmName}
                      </Typography>
                    </Grid>

                  
                  </Grid>
                </div>
              </Grid>
            ))}
          </Grid> */}
          
        </Box>
      </Modal>
    </>
  );
};

export default GCAuditTblCard;
